import React from 'react';

type Props = {
    children?: React.ReactNode;
};

function FooterFixed(props: Props) {
    return props.children ? <div className="footer-fixed">{props.children}</div> : null;
}

export default FooterFixed;
